module.exports = __webpack_public_path__ + "static/img/code.5e41bd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/code.jpg
// module id = pumF
// module chunks = 1